<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="0">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="selectedComponent == 'files'"
                                @invoke-method="invokeMethod($event)"
                                action="showPartFile"
                                target-ref="partComponents"
                                :tooltip="$t('lang.add_part_file')"
                                perm="parts.update"
                            ></bc-btn-add>
                            <bc-btn-add
                                v-if="selectedComponent == 'spec'"
                                @invoke-method="invokeMethod($event)"
                                action="showPartSpec"
                                target-ref="partComponents"
                                :tooltip="$t('lang.add_part_spec')"
                                perm="parts.update"
                            ></bc-btn-add>
                            <bc-btn-add
                                v-if="selectedComponent == 'process'"
                                @invoke-method="invokeMethod($event)"
                                action="openPartStation"
                                target-ref="partComponents"
                                :tooltip="$t('lang.add_part_station')"
                                perm="parts.update"
                            ></bc-btn-add>
                            <!-- <v-menu v-if="selectedComponent == 'process'" content-class="no-stripe">
                                <v-btn icon slot="activator">
                                    <v-icon>add</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile v-for="item in addList" :key="item.title" @click="$emit('invoke-method', item)">
                                        <v-list-tile-title>
                                            {{ item.title }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu> -->
                            <bc-btn-refresh @invoke-method="dbGetPart()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="fullMobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="profile != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 pb-0 :pl-0="!$bp.smallScreen" align-self-start :class="{ 'prevent-click': !hasPerm('parts.update') }">
                            <v-layout row wrap>
                                <v-flex xs9 py-0>
                                    <bc-tooltip right v-if="hasPerm('parts.update')">
                                        <template slot="activator">
                                            <v-btn
                                                style="max-width: 120px; text-transform: none"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="currObjField('active') == '1' ? 'green' : 'red'"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" :value="currObjField('active')">{{
                                                    status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"
                                                }}</v-icon>
                                                <span class="white--text">{{ currObjField("active") == "1" ? "Active" : "Inactive" }}</span>
                                            </v-btn>
                                        </template>
                                        {{ currObjField("active") == "1" ? $t("lang.click_to_deactivate") : $t("lang.click_to_activate") }}
                                    </bc-tooltip>
                                    <v-chip
                                        v-else
                                        disabled
                                        round
                                        text-color="white"
                                        class="chip-padding-left-4 mr-auto fs-14"
                                        :color="currObjField('active') == '1' ? 'green' : 'red'"
                                    >
                                        <span><v-icon :value="currObjField('active')" class="mr-2">check_circle</v-icon></span>
                                        <span class="white--text">{{ currObjField("active") == "1" ? "Active" : "Inactive" }}</span>
                                    </v-chip>
                                </v-flex>
                                <v-flex xs3 pr-0 py-0>
                                    <bc-tooltip class="ml-auto" perm="parts.update">
                                        <template slot="activator">
                                            <v-btn icon @mouseup.left="openPartDialog('part')">
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t("lang.modify_part") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs12 py-0>
                                    <bc-tooltip top>
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg || (profile && !profile.photo) ? errorImg : profile.photo"
                                                height="150px"
                                                width="150px"
                                                class="rounded-circle mx-auto clickable"
                                                @mouseup.left="hasPerm('parts.update') ? $refs.croppa.chooseFile() : ''"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t("lang.uploadImage") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex class="clickable py-1" @mouseup.left="openPartDialog('part')">
                                    <p class="display-1 mb-0 text-xs-center">{{ profile.name }}</p>
                                    <p class="fs-22 mb-0 text-xs-center">{{ profile.customer_part_number }}</p>
                                    <p class="display-0 mb-0 text-xs-center">
                                        Warehouse Qty: <span class="fs-18 font-weight-bold">{{ profile.warehouse_qty | with_commas }}</span>
                                    </p>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" prepend-position="top" perm="parts.update" @invoke-method="openPartDialog('part')">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.project_name")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.project_name }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.dta_part_code")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.dta_part_code }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.process_part_code")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.process_part_code }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.company")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.company }}</v-flex> <v-flex xs7 mt-1>{{ `${$t("lang.material")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.material }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.od_dimension")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.od_dimension && +profile.od_dimension > 0 && !!profile.od_unit_abbrev
                                                    ? `${profile.od_dimension} ${profile.od_unit_abbrev}`
                                                    : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.height_dimension")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.height_dimension && +profile.height_dimension > 0 && !!profile.height_unit_abbrev
                                                    ? `${profile.height_dimension} ${profile.height_unit_abbrev}`
                                                    : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.id_dimension")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.id_dimension && +profile.id_dimension > 0 && !!profile.id_unit_abbrev
                                                    ? `${profile.id_dimension} ${profile.id_unit_abbrev}`
                                                    : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.part_weight")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.weight_kg && +profile.weight_kg > 0 ? `${profile.weight_kg} kg` : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.packaging_weight")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.packaging_weight ? `${profile.packaging_weight} lb` : "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.batch_size_pcs")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.batch_size }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.jig_assembly_id")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.jig_assembly_id || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.production_line")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.production_line || "---" }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="currObjField('line_id') == '1'">{{ `${$t("lang.qc_check_interval")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1 v-if="currObjField('line_id') == '1'">{{ profile.qc_check_interval || "---" }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="currObjField('line_id') == '2'">{{ `${$t("lang.cycle_time")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1 v-if="currObjField('line_id') == '2'">{{
                                                profile.cycle_time + " " + `${$t("lang.minutes")}` || "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.hazardous_material")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.hazardous_material ? (profile.hazardous_material == "1" ? $t("lang.yes") : $t("lang.no")) : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.default_shipping_unit")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.repack_shipping_unit ? profile.repack_shipping_unit : "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.receiving_qty_pcs")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.receiving_qty ? profile.receiving_qty : "---" }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="task" prepend-position="top" perm="parts.update" @invoke-method="openPartDialog('quote')">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.quote_number")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.quotation_number || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.quote_date")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.quotation_date || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.salesman")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.salesman || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.po_number")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{
                                                profile.po_number ? profile.po_number + (profile.blank_po == "1" ? " (B)" : "") : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.part_cost")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>${{ profile.part_cost || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.sales_price")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>${{ profile.sales_label || "---" }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="currObjField('sales_unit') == '1'">{{ `${$t("lang.batch_price")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1 v-if="currObjField('sales_unit') == '1'">{{
                                                total_batch_price ? `$${total_batch_price}` : "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.remuneration_cost")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>${{ profile.remuneration_cost || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.acceptance_test_qty")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.acceptance_test_qty || "---" }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="lock" prepend-position="top" perm="parts.update" @invoke-method="openPartDialog('authorized')">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.production")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.in_production == "1" ? $t("lang.mass") : $t("lang.prototype") }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.authorized_by_id")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.authorized_by || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.authorized_date")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.authorized_date || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.authorization_rev")}:` }}</v-flex
                                            ><v-flex xs5 fw-bold mt-1>{{ profile.authorization_rev || "---" }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <bc-tabs
                                    :tabs="tabs"
                                    :selectedComponent="selectedComponent"
                                    @button="$nextTick(() => (selectedComponent = $event))"
                                    :update-params="true"
                                >
                                </bc-tabs>
                                <v-card elevation="0" :key="refresh">
                                    <keep-alive>
                                        <component
                                            v-if="profile"
                                            :is="`part_${selectedComponent}`"
                                            ref="partComponents"
                                            :table-loader="tableLoader"
                                            :part="profile"
                                            class="tab"
                                        ></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        <bc-dialog :value="authorized_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.authorization_info") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="closePartDialog('authorized')" :dialog-status="authorized_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="part.authorized_by_id"
                                        :label="$t('lang.authorized_by_id')"
                                        :items="authorized_by"
                                        :initial="currObjField('authorized_by')"
                                        item-value="people_id"
                                        item-text="combined_name"
                                        :rules="ifValid('part.authorized_by_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-date-picker
                                        v-model="part.authorized_date"
                                        :label="$t('lang.authorized_date')"
                                        :rules="ifValid('part.authorized_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="part.authorization_rev"
                                        :label="`${$t('lang.authorization_rev')} *`"
                                        :counter="showCounter(part.authorization_rev, 'part.authorization_rev')"
                                        :rules="ifValid('part.authorization_rev')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-switch
                                        v-model="part.in_production"
                                        :label="part.in_production == '1' ? $t('lang.in_production') : $t('lang.prototype')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closePartDialog('authorized')">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn v-if="currObjField('part_id') ? hasScope('update') : hasScope('create')" color="success" @mouseup.left="modifyPart('authorized')">
                        {{ $t("lang.save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-dialog :value="quote_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.quote_info") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="closePartDialog('quote')" :dialog-status="quote_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="part.quotation_number"
                                        :label="$t('lang.quotation_number')"
                                        :counter="showCounter(part.quotation_number, 'part.quotation_number')"
                                        :rules="ifValid('part.quotation_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-date-picker
                                        v-model="part.quotation_date"
                                        :label="$t('lang.quotation_date')"
                                        :rules="ifValid('part.quotation_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-autocomplete
                                        v-model="part.salesman_id"
                                        :label="$t('lang.salesman')"
                                        :items="authorized_by"
                                        :initial="currObjField('salesman')"
                                        item-value="people_id"
                                        item-text="combined_name"
                                        :rules="ifValid('part.salesman_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap>
                                        <v-flex xs7 inner-flex>
                                            <v-text-field
                                                v-model="part.po_number"
                                                :label="$t('lang.po_number')"
                                                :counter="showCounter(part.po_number, 'part.po_number')"
                                                :rules="ifValid('part.po_number')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs5 pl-1 inner-flex>
                                            <v-switch
                                                v-model="part.blank_po"
                                                :label="part.blank_po == '1' ? $t('lang.blanket_yes') : $t('lang.blanket_no')"
                                                true-value="1"
                                                false-value="0"
                                                ripple
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="part.part_cost"
                                        :label="$t('lang.part_cost')"
                                        :counter="showCounter(part.part_cost, 'part.part_cost')"
                                        :rules="ifValid('part.part_cost')"
                                        prefix="$"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap>
                                        <v-flex xs8 inner-flex>
                                            <v-text-field
                                                v-model="part.sales_price"
                                                :label="`${$t('lang.sales_price')} *`"
                                                :counter="showCounter(part.sales_price, 'part.sales_price')"
                                                :rules="ifValid('part.sales_price')"
                                                prefix="$"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4 pl-1 inner-flex>
                                            <bc-autocomplete
                                                v-model="part.sales_unit"
                                                :label="$t('lang.unit')"
                                                :items="sales_unit_options"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('part.sales_unit')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="part.remuneration_cost"
                                        :label="$t('lang.remuneration_cost')"
                                        :counter="showCounter(part.remuneration_cost, 'part.remuneration_cost')"
                                        :rules="ifValid('part.remuneration_cost')"
                                        prefix="$"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="part.acceptance_test_qty"
                                        :label="$t('lang.acceptance_test_qty')"
                                        :counter="showCounter(part.acceptance_test_qty, 'part.acceptance_test_qty')"
                                        :rules="ifValid('part.acceptance_test_qty')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closePartDialog('quote')">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn v-if="currObjField('part_id') ? hasScope('update') : hasScope('create')" color="success" @mouseup.left="modifyPart('quote')">
                        {{ $t("lang.save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-dialog :value="part_dialog" max-width="1000">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.edit_part") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="closePartDialog('part')" :dialog-status="part_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.name"
                                        :label="`${$t('lang.part_name')} *`"
                                        :counter="showCounter(part.name, 'part.name')"
                                        :rules="ifValid('part.name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-focus="part_dialog"
                                        v-model="part.project_name"
                                        :label="$t('lang.project_name')"
                                        :counter="showCounter(part.project_name, 'part.project_name')"
                                        :rules="ifValid('part.project_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        :value="profile.dta_part_code"
                                        :label="`${$t('lang.dta_part_code')}`"
                                        readonly
                                        append-icon="lock"
                                        class="prevent-click"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.process_part_code"
                                        :label="`${$t('lang.process_part_code')}`"
                                        :counter="showCounter(part.process_part_code, 'part.process_part_code')"
                                        :rules="ifValid('part.process_part_code')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.customer_part_number"
                                        :label="`${$t('lang.part_number')} *`"
                                        :counter="showCounter(part.customer_part_number, 'part.customer_part_number')"
                                        :rules="ifValid('part.customer_part_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <bc-autocomplete
                                        v-model="part.company_id"
                                        :label="`${$t('lang.company_id')} *`"
                                        :items="customer_options"
                                        item-value="company_id"
                                        item-text="company"
                                        :rules="ifValid('part.company_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.material"
                                        :label="`${$t('lang.material')} *`"
                                        :counter="showCounter(part.material, 'part.material')"
                                        :rules="ifValid('part.material')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.weight_kg"
                                        :label="`${$t('lang.part_weight')} *`"
                                        :counter="showCounter(part.weight_kg, 'part.weight_kg')"
                                        :rules="ifValid('part.weight_kg')"
                                        suffix="kg"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.packaging_weight"
                                        :label="`${$t('lang.packaging_weight')} *`"
                                        :counter="showCounter(part.packaging_weight, 'part.packaging_weight')"
                                        :rules="ifValid('part.packaging_weight')"
                                        suffix="lb"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-layout row wrap>
                                        <v-flex xs8 inner-flex>
                                            <v-text-field
                                                v-model="part.od_dimension"
                                                :label="$t('lang.od_dimension')"
                                                :counter="showCounter(part.od_dimension, 'part.od_dimension')"
                                                :rules="ifValid('part.od_dimension')"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4 pl-1 inner-flex>
                                            <bc-autocomplete
                                                v-model="part.od_unit_id"
                                                :label="$t('lang.unit')"
                                                :items="units_of_measure || []"
                                                item-value="id"
                                                item-text="unit_abbrev"
                                                :rules="ifValid('part.od_unit_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-layout row wrap>
                                        <v-flex xs8 inner-flex>
                                            <v-text-field
                                                v-model="part.id_dimension"
                                                :label="$t('lang.id_dimension')"
                                                :counter="showCounter(part.id_dimension, 'part.id_dimension')"
                                                :rules="ifValid('part.id_dimension')"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4 pl-1 inner-flex>
                                            <bc-autocomplete
                                                v-model="part.id_unit_id"
                                                :label="$t('lang.unit')"
                                                :items="units_of_measure || []"
                                                item-value="id"
                                                item-text="unit_abbrev"
                                                :rules="ifValid('part.id_unit_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-layout row wrap>
                                        <v-flex xs8 inner-flex>
                                            <v-text-field
                                                v-model="part.height_dimension"
                                                :label="$t('lang.height_dimension')"
                                                :counter="showCounter(part.height_dimension, 'part.height_dimension')"
                                                :rules="ifValid('part.height_dimension')"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4 pl-1 inner-flex>
                                            <bc-autocomplete
                                                v-model="part.height_unit_id"
                                                :label="$t('lang.unit')"
                                                :items="units_of_measure || []"
                                                item-value="id"
                                                item-text="unit_abbrev"
                                                :rules="ifValid('part.height_unit_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <bc-autocomplete
                                        v-model="part.line_id"
                                        :label="$t('lang.line_id')"
                                        :items="production_lines"
                                        item-value="line_id"
                                        item-text="production_line"
                                        :rules="ifValid('part.line_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.batch_size"
                                        :label="`${$t('lang.batch_size')} *`"
                                        :counter="showCounter(part.batch_size, 'part.batch_size')"
                                        :rules="ifValid('part.batch_size')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.jig_assembly_id"
                                        :label="$t('lang.jig_assembly_id')"
                                        :counter="showCounter(part.jig_assembly_id, 'part.jig_assembly_id')"
                                        :rules="ifValid('part.jig_assembly_id')"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.cycle_time"
                                        :label="$t('lang.cycle_time')"
                                        :counter="showCounter(part.cycle_time, 'part.cycle_time')"
                                        :rules="ifValid('part.cycle_time')"
                                        :suffix="$t('lang.minutes').toLowerCase()"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <bc-autocomplete
                                        v-model="part.repack_shipping_unit_id"
                                        :label="$t('lang.default_repack_shipping_unit')"
                                        :items="shipping_unit_options"
                                        item-value="shipping_unit_id"
                                        item-text="shipping_unit"
                                        :rules="ifValid('part.repack_shipping_unit_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-model="part.receiving_qty"
                                        :label="$t('lang.receiving_qty')"
                                        :counter="showCounter(part.receiving_qty, 'part.receiving_qty')"
                                        :rules="ifValid('part.receiving_qty')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        v-if="part.line_id == '1'"
                                        v-model="part.qc_check_interval"
                                        :label="$t('lang.qc_check_interval')"
                                        :counter="showCounter(part.qc_check_interval, 'part.qc_check_interval')"
                                        :rules="ifValid('part.qc_check_interval')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-select
                                        v-if="part.line_id == '1'"
                                        :items="[
                                            { value: '1', text: 'Yes' },
                                            { value: '0', text: 'No' },
                                        ]"
                                        v-model="part.require_qc_before_repack"
                                        :label="$t('lang.require_qc_before_repack')"
                                        :counter="showCounter(part.require_qc_before_repack, 'part.require_qc_before_repack')"
                                        :rules="ifValid('part.require_qc_before_repack')"
                                        type="number"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-switch
                        v-model="part.hazardous_material"
                        :label="`${$t('lang.hazardous_material')}: ${part.hazardous_material == '1' ? $t('lang.yes') : $t('lang.no')}`"
                        true-value="1"
                        false-value="0"
                    ></v-switch>
                    <!-- <v-btn v-if="currObjField('part_id') && hasScope('delete')" color="error" @mouseup.left="$refs.delete_part.openDialog()">{{ $t('lang.delete') }}</v-btn> -->
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closePartDialog('part')">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn v-if="currObjField('part_id') ? hasScope('update') : hasScope('create')" color="success" @mouseup.left="modifyPart('part')">
                        {{ $t("lang.save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_part"
            :heading="$t('lang.delete_part')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyTankProduct('delete', currObjField('product_id'))"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import part_spec from "Modules/manufacturing/parts/components/Spec";
import part_files from "Modules/manufacturing/parts/components/Files";
import part_process from "Modules/manufacturing/parts/components/Process";
import { store } from "Store/store";
import { mapGetters, mapState, mapActions } from "vuex";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            selectedComponent: "spec",
            newFile: {
                photo_file: "",
            },
            updatePhoto: 0,
            part: {
                blank_po: "",
                project_name: "",
                customer_part_number: "",
                process_part_code: "",
                name: "",
                company_id: "",
                end_user: "",
                vehicle_model: "",
                sop_date: "",
                material: "",
                od_dimension: "",
                od_unit_id: "",
                height_dimension: "",
                height_unit_id: "",
                id_dimension: "",
                id_unit_id: "",
                weight_kg: "0.000",
                batch_size: "",
                authorized_by_id: "",
                authorized_date: "",
                authorization_rev: "",
                sales_price: "0.00",
                sales_unit: "",
                part_cost: "",
                remuneration_cost: "",
                acceptance_test_qty: "",
                jig_assembly_id: "",
                line_id: "",
                in_production: "",
                quotation_number: "",
                quotation_date: "",
                qc_check_interval: "",
                salesman_id: "",
                po_number: "",
                hazardous_material: "",
                cycle_time: "",
                packaging_weight: "0.00",
                repack_shipping_unit_id: "",
                receiving_qty: "",
                require_qc_before_repack: "0",
            },
            customers: null,
            refresh: 0,
            errorImg: AppConfig.baseApiUrl + "/public/default_part.png",
            showErrorImg: false,
            authorized_dialog: false,
            part_dialog: false,
            quote_dialog: false,
            editStatus: {
                status: "",
            },
            status_loader: false,
            tableLoader: false,
            // addList: [
            //     { title: this.$t('lang.addPreWash'), action: "showPhone", ref: 'phoneDialog', icon: "phone" },
            //     { title: this.$t('lang.addWash'), action: "showEmail", ref: 'emailDialog', icon: "email" },
            //     { title: this.$t('lang.addFurnace'), action: "showAddress", ref: 'addressDialog', icon: "location_on" },
            //     { title: this.$t('lang.addTempering'), action: "openTokenDialog", icon: "generating_tokens" },
            // ],
            unit_options: [
                { value: "1", text: "mm" },
                { value: "2", text: "inches" },
            ],
            sales_unit_options: [
                { value: "0", text: "Piece" },
                { value: "1", text: "Batch" },
            ],
            authorized_by: null,
            tabs: [
                { title: "part_spec", name: "spec" },
                { title: "files", name: "files" },
                { title: "process", name: "process" },
            ],
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetPart: _.debounce(this.getPart, 1500, { maxWait: 1500, leading: true, trailing: false }),
            units_of_measure: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        const part = new Promise((resolve, reject) => {
            store
                .dispatch("fetchPart", {
                    url: "parts/" + to.params.id,
                    method: "get",
                    stateProperty: "part|parts_spec|parts_files|parts_stations",
                    dataProperty: "parts|parts.parts_spec|parts.files|parts.parts_stations",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.parts ? resolve(data.parts) : reject(new Error("reject"));
                });
        });
        Promise.all([part])
            .then(([part]) => {
                next((vm) => {
                    vm.selectedComponent = to.params.tab && vm.tabs.map((t) => t.name).indexOf(to.params.tab) >= 0 ? to.params.tab : vm.tabs[0].name;
                    vm.assignObj(vm.part, part);
                    vm.finishLoader();
                    vm.$store.commit("toggleModalLoader", false);
                    // TODO: based on perms can delete authorized fields from part object
                    vm.editStatus = {
                        status: part.status,
                    };
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const part = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchPart", {
                    url: "parts/" + to.params.id,
                    method: "get",
                    stateProperty: "part|parts_spec|parts_files|parts_stations",
                    dataProperty: "parts|parts.parts_spec|parts.files|parts.parts_stations",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.parts ? resolve(data.parts) : reject(new Error("reject"));
                });
        });

        Promise.all([part])
            .then(([part]) => {
                this.selectedComponent = to.params.tab && this.tabs.map((t) => t.name).indexOf(to.params.tab) >= 0 ? to.params.tab : this.tabs[0].name;
                this.finishLoader();
                this.assignObj(this.part, part);
                this.editStatus = {
                    status: part.status,
                };
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, path to dashboard
            });
    },
    computed: {
        ...mapState({
            profile: (state) => state.parts.part,
            rules_part: (state) => state.validation.rules_part,
            production_lines: (state) => state.production.production_lines,
            shipping_unit_options: (state) => state.settings.shipping_unit_options,
            customer_options: (state) => state.customers.customer_options,
        }),
        ...mapGetters(["login_types"]),
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
        hasScope() {
            return (scope) => {
                return this.currObjField("scope").includes(`${scope}`) || !this.currObjField("part_id");
            };
        },
        fullMobileList() {
            let fullList = [{ title: this.$t("lang.refresh"), action: "dbGetPart" }];
            if (this.selectedComponent == "files") {
                fullList.unshift({ title: this.$t("lang.add_part_file"), action: "showPartFile", ref: "partComponents", perms: ["parts.update"] });
            } else if (this.selectedComponent == "spec") {
                fullList.unshift({ title: this.$t("lang.add_part_spec"), action: "showPartSpec", ref: "partComponents", perms: ["parts.update"] });
            } else if (this.selectedComponent == "process") {
                fullList.unshift({ title: this.$t("lang.add_part_station"), action: "openPartStation", ref: "partComponents", perms: ["parts.update"] });
            }
            return fullList;
        },
        total_batch_price() {
            let batch_price = null;
            let batch_size = +this.currObjField("batch_size");
            let sales_price = +this.currObjField("sales_price");
            if (this.currObjField("sales_unit") == "1" && batch_size > 0 && sales_price > 0) {
                batch_price = batch_size * sales_price;
                batch_price = (Math.round(batch_price * 1e3) / 1e3).toFixed(3);
            }
            return batch_price;
        },
    },
    methods: {
        ...mapActions(["fetchCustomers", "fetchUnitsOfMeasure"]),
        openPartDialog(dialog) {
            this.getArrayData(dialog);
            this.assignObj(this.part, this.profile);
            this[`${dialog}_dialog`] = true;
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        getPart(status = true) {
            if (status) {
                this.refresh++;
                this.startLoader();
                this.tableLoader = true;
            }
            this.$store
                .dispatch("fetchPart", {
                    url: `parts/${this.$route.params.id}`,
                    method: "get",
                    stateProperty: "part|parts_spec|parts_files|parts_stations",
                    dataProperty: "parts|parts.parts_spec|parts.files|parts.parts_stations",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.parts) {
                        this.assignObj(this.part, data.parts);
                    } else {
                        this.$router.push({ name: "parts" });
                    }
                })
                .finally(() => {
                    if (this.profile) {
                        this.$nextTick(() => {
                            this.finishLoader(true);
                            this.$store.commit("validationOff");
                            this.$store.commit("toggleModalLoader", false);
                            this.tableLoader = false;
                            this.status_loader = false;
                            this.editStatus = {
                                status: this.profile.status,
                            };
                            if (this.selectedComponent == "files" && status) {
                                this.$refs.partComponents.setRequiredCategoriesMissing();
                            }
                        });
                    }
                });
        },
        getArrayData(dialog = null) {
            if (this.production_lines == null) this.getProductionLines();
            if (this.customers == null) this.getCustomers();
            if (this.shipping_unit_options == null && dialog == "part") this.getShippingUnitOptions();
            if (dialog != "part" && this.authorized_by == null) this.getEmployees();
        },
        closePartDialog(dialog) {
            this[`${dialog}_dialog`] = false;
            this.$refs.delete_part.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        handleFileUpload(file) {
            this.newFile.photo_file = file;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("uploadPartPhoto", {
                    url: `parts/${this.$route.params.id}/photo`,
                    stateProperty: "part",
                    dataProperty: "parts",
                    commit: true,
                    body: this.newFile,
                })
                .then((data) => {})
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
        modifyPart(dialog) {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("part")) {
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchPart", {
                            url: `parts/${this.$route.params.id}`,
                            method: "patch",
                            stateProperty: "part|parts_spec|parts_files",
                            dataProperty: "parts|parts.parts_spec|parts.files",
                            commit: true,
                            body: this.part,
                        })
                        .then((data) => {
                            if (data) {
                                this.$store.commit("validationOff");
                                this[`${dialog}_dialog`] = false;
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            });
        },
        getEmployees() {
            this.$store
                .dispatch("fetchPeople", {
                    url: "people",
                    method: "get",
                    body: {
                        slug: "employee",
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.people) {
                        this.authorized_by = data.people;
                    }
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 ? "1" : "0" } });
            /*this.$store
                .dispatch("fetchCustomers", {
                    url: "customers",
                    method: "get",
                    body: this.axiosParams,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.customers;
                    }
                });*/
        },
        changeStatus() {
            this.status_loader = true;
            this.profile.active == 1 ? (this.editStatus.active = 0) : (this.editStatus.active = 1);
            this.$store
                .dispatch("fetchPart", {
                    url: `parts/${this.$route.params.id}`,
                    method: "patch",
                    stateProperty: "part",
                    dataProperty: "parts",
                    commit: true,
                    body: this.editStatus,
                })
                .then((data) => {
                    if (data) {
                        this.status_loader = false;
                        this.finishLoader();
                    }
                });
        },
        getShippingUnitOptions() {
            this.$store.dispatch("fetchSetting", {
                url: "shipping_unit_options",
                method: "get",
                stateProperty: "shipping_unit_options",
                commit: true,
            });
        },
    },
    components: {
        part_spec,
        part_files,
        part_process,
    },
    mounted() {
        if (this.units_of_measure.length == 0 || force == true) {
            // await this.fetchUnitsOfMeasure({ body: { options: 1 } })
            this.fetchUnitsOfMeasure({ body: { options: 1 } }).then((data) => {
                if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                this.units_of_measure = data.units_of_measure;
            });
        }
    },
};
</script>
